import { animated } from '#app/components/Primitives/Animated.js';
import { springAnimation } from '#app/utilities/animation.js';
import { type ReactNode } from 'react';
import { styled } from 'styled-components';

const MotionCard = styled(animated.div)`
  width: 100%;
`;

export const CardListItemAnimation = ({
  children,
  className,
  isFirstElement = false,
}: {
  readonly children: ReactNode;
  readonly className?: string;
  readonly isFirstElement?: boolean;
}) => {
  return (
    <MotionCard
      animate={{ opacity: 1, y: 0 }}
      className={className}
      exit={{ opacity: 0 }}
      initial={{ opacity: 0, y: isFirstElement ? 0 : -16 }}
      transition={{ ...springAnimation.verySlow, staggerChildren: 0.5 }}
    >
      {children}
    </MotionCard>
  );
};
